import utils from './lib/utils';
import common from './modules/common';
import '../vendor/jquery-select';

common();

$(function() {
    if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
            let $recaptcha = $('#j-recaptcha-token-register');
            grecaptcha.execute($recaptcha.attr('data-key'), {action: 'register'}).then(function(token) {
                $recaptcha.val(token);
            });
        });
    }

    let $email = $('#email-address');
    let $pass = $('#password');
    let $passwordTooltip = $('#passwordTooltip');

    const checkPass = function () {

        let regex = new RegExp(/^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])).{8,}$/);
        let valid = regex.test($pass.val());

        if (valid) {
            $pass.parents('fieldset').removeClass('error');
        } else {
            $pass.parents('fieldset').addClass('error');
        }

        return valid;
    };

    $('#occupation-field').selectOverlap();

    const checkEmail = function () {

        let filter = /[^\s@]+@[^\s@]+\.[^\s@]+/,
            valid = filter.test($email.val());

        if (valid) {
            $email.parents('fieldset').removeClass('error');
        } else {
            $email.parents('fieldset').addClass('error');
        }

        return valid;
    };

    $email.on('blur', function () {
        checkEmail();
    });

    $email.on('keyup', function () {
        if ($(this).parents('fieldset').hasClass('error')) {
            checkEmail();
        }
    });

    $('#register-account').on('submit', function (e) {
        let validPass = checkPass(),
            validEmail = checkEmail(),
            valid = validPass && validEmail;

        e.preventDefault();

        if (!valid) {
            return;
        }

        if (!$('input[name=confirm-privacy]').is(':checked')) {
            $(this).find('.j-terms-error').show();
            return;
        } else {
            $(this).find('.j-terms-error').hide();
        }

        let $submit = $(this).find('button[type=submit]');
        $submit.prop('disabled', true);
        $submit.find('.loading').css('display', 'block');

        this.submit();
    });

    $pass.on('focus', function() {
        $passwordTooltip.show();
    });

    $pass.on('focusout', function() {
        $passwordTooltip.hide();
        checkPass();
    });

    $pass.on('keyup', function () {
        utils.checkPasswordTooltip($pass);
        
        if ($(this).parents('fieldset').hasClass('error')) {
            checkPass();
        }
    });
});    
